import { useEffect } from 'react';
import { submissionPolling } from '../../store/submissionPolling';

const PAGE_VISIBLE: DocumentVisibilityState = 'visible';
const VISIBILITY_CHANGE_EVENT = 'visibilitychange';
const ONLINE_EVENT = 'online';

/**
 * Checks again on every submission this app stopped checking after repeated lookup failures, when
 * the page becomes visible again or the browser reconnects: the give-up was about the connection,
 * so those are the moments it may be over.
 */
const useResumeSubmissionChecksOnReturn = (): void => {
  useEffect(() => {
    const resumeWhenPageVisible = (): void => {
      if (document.visibilityState === PAGE_VISIBLE) {
        submissionPolling.resumeAllAfterGiveUp();
      }
    };
    const resumeWhenOnline = (): void => {
      submissionPolling.resumeAllAfterGiveUp();
    };

    document.addEventListener(VISIBILITY_CHANGE_EVENT, resumeWhenPageVisible);
    window.addEventListener(ONLINE_EVENT, resumeWhenOnline);

    return (): void => {
      document.removeEventListener(VISIBILITY_CHANGE_EVENT, resumeWhenPageVisible);
      window.removeEventListener(ONLINE_EVENT, resumeWhenOnline);
    };
  }, []);
};

export default useResumeSubmissionChecksOnReturn;
